import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { BidHistory } from 'remarketing-angular-library';
import { BidModalItem } from '../../models/bid-modal-item.model';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { takeUntil } from 'rxjs';
import { ModalCloseComponent } from 'src/shared/ui/comment/modal-actions/modal-close/modal-close.component';
import { OfferModalsHeaderComponent } from 'src/shared/ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { OfferHistoryComponent } from '../offer-modals/offer-history/offer-history.component';

@Component({
    selector: 'app-bid-history-modal',
    templateUrl: './bid-history-modal.component.html',
    styleUrls: ['./bid-history-modal.component.scss'],
    imports: [ModalCloseComponent, OfferModalsHeaderComponent, ModalComponent, OfferHistoryComponent, TranslocoDirective]
})
export class BidHistoryModalComponent extends SaComponent implements OnInit {
  constructor(private readonly translocoService: TranslocoService) {
    super();
  }

  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() modalItem: BidModalItem;
  @Input() modalId = 'Bid-History';
  @Input() tenantName: string;
  @Input() bidHistory: BidHistory[];

  bidHistoryModalTranslations = {
    heading: ''
  };

  ngOnInit() {
    this.getTranslations();
  }

  show() {
    this.modal.show();
  }

  cancel() {
    this.modal.close();
  }

  getTranslations() {
    const keyParams = {
      'vehicles.bidlistInventoryItem': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.bidHistoryModalTranslations.heading = translate[0].bidhistoryModalHeading;
      });
  }
}
